import { apiCaller } from '../ApiCaller/ApiCaller';

export async function updateLeadDataOfContact(leadData) {

    const updateLeadData  = apiCaller("https://salesforceb2b.customers.bigfivecrm.com/updateLeadDetail", leadData);

      return updateLeadData;
}